function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import vent from 'elements/vent';
import $ from 'jquery';
import flatpickr from 'flatpickr/dist/flatpickr';
import { French } from 'flatpickr/dist/l10n/fr.js';
export var utils = new ( /*#__PURE__*/function () {
  function Utils() {
    _classCallCheck(this, Utils);
    vent.on('PCS:SUBMIT_FORM', this.onSubmitForm.bind(this));
    vent.on('PCS:RELOAD_ITEM', this.onReloadItem.bind(this));
    $(document).on('ajaxStart', function () {
      $('body').addClass('page-is-loading').attr('aria-busy', true);
    }).on('ajaxComplete pjax:end', function (e) {
      $(window).trigger('scroll');
      $('body').removeClass('page-is-loading').attr('aria-busy', false);
    });
    $(document).on('change', 'input[type="file"]', this.onTypeFileChange.bind(this));
    $(document).on('submit', 'form[data-form="del"]', this.onFormDeleteSubmit.bind(this));
    $(document).on('click', '.show-more__btn', this.onShowMoreClick.bind(this));
  }
  _createClass(Utils, [{
    key: "destroy",
    value: function destroy() {
      if (this.homepage && this.homepageVideo && this.homepageVideo.streamPlayer) {
        window.homepageVisited = true;
        this.homepageVideo.pause();
        this.homepageVideo.streamPlayer["delete"]();
        var more = this.homepage.querySelector('.intro-more-btn');
        if (more) more.removeEventListener('click', this.handler.moreClick);
        this.homepageVideo = null;
        this.homepage = null;
        window.device.muted = false;
      }
    }
  }, {
    key: "onShowMoreClick",
    value: function onShowMoreClick(e) {
      e.preventDefault();
      var $parent = $(e.target).parent();
      var $more = $parent.find('.show-more');
      $more.removeClass('sr-only');
      $(e.target).remove();
    }
  }, {
    key: "onTypeFileChange",
    value: function onTypeFileChange(e) {
      var $el = $(e.target);
      try {
        var max = $el.attr('data-maxsize');
        if (max === undefined) {
          max = 3000;
        }
        var size = $el[0].files[0].size;
        if (size >= max * 1000) {
          $el.val('');
          var msg = 'Le fichier est trop volumineux. La taille des fichiers est limitée à [size] Mo';
          alert(msg.replace('[size]', max / 1000));
        }
      } catch (e) {}
    }
  }, {
    key: "onSubmitForm",
    value: function onSubmitForm(_ref) {
      var form = _ref.form,
        successCallback = _ref.successCallback,
        errorCallback = _ref.errorCallback;
      $.ajax({
        url: form.attr('action'),
        data: new FormData(form[0]),
        method: 'POST',
        type: 'POST',
        cache: false,
        contentType: false,
        dataType: 'json',
        processData: false,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-WP-Nonce': PCS_Settings.nonce
        },
        success: function success(response) {
          if (response && response.template) {
            vent.publish('PCS:RELOAD_ITEM', {
              template: response.template
            });
          }
          if (response && response.flash) {
            vent.publish('FLASH:SHOW', {
              flash: response.flash,
              error: false
            });
          }
          if (successCallback) {
            successCallback(response);
          }
          if (response && response.vent) {
            vent.publish(response.vent);
          }
        },
        error: function error(_error) {
          if (errorCallback) {
            vent.publish('FLASH:SHOW', {
              flash: 'Une erreur est survenue ... ',
              error: true
            });
            errorCallback(_error);
          }
        }
      });
    }
  }, {
    key: "onReloadItem",
    value: function onReloadItem(_ref2) {
      var template = _ref2.template;
      $('#pcs-form-container').replaceWith(template);
      window.scrollTo(0, 0);
      vent.publish('PCS:REFRESH_UI');
    }
  }, {
    key: "onFormDeleteSubmit",
    value: function onFormDeleteSubmit(e) {
      e.preventDefault();
      vent.publish('PCS:SUBMIT_FORM', {
        form: $(e.target),
        successCallback: function successCallback(response) {
          $(e.target).parents('[data-form-delete]').remove();
        },
        errorCallback: function errorCallback(response) {}
      });
    }
  }]);
  return Utils;
}())();